// extracted by mini-css-extract-plugin
export var footerContainer = "footer-module--footerContainer--7WLiC";
export var columns = "footer-module--columns--4Nyo3";
export var logoColumn = "footer-module--logoColumn--uw2VU";
export var socialIcon = "footer-module--socialIcon--hb-3D";
export var email = "footer-module--email--AyxOP";
export var footerLink = "footer-module--footerLink--94ZRs";